import React from "react";

const SalesAnalyticsIcon = ({ style }) => (
    <div className="menu-icon" style={style}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="2"  y="14" width="4" height="7" rx="1" />
            <rect x="9"  y="9"  width="4" height="12" rx="1" />
            <rect x="16" y="4"  width="4" height="17" rx="1" />
        </svg>
    </div>
);

export default SalesAnalyticsIcon;
